import { render, staticRenderFns } from "./view-item-image.vue?vue&type=template&id=33256dac&"
import script from "./view-item-image.vue?vue&type=script&lang=js&"
export * from "./view-item-image.vue?vue&type=script&lang=js&"
import style0 from "./view-item-image.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QImg,QSpinnerIos,QDialog,QCard,QBar,QSpace,QBtn,QTooltip,QCardSection,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QImg,QSpinnerIos,QDialog,QCard,QBar,QSpace,QBtn,QTooltip,QCardSection})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
